export { default } from './TooltipText';
